import axios from 'axios';

const defaultBackingsEndpoint = 'https://furgediak.hu/furgediak-backings/methods/';
const backingsEndpoint = process.env.REACT_APP_BACKINGS_ENDPOINT || defaultBackingsEndpoint;

global.backingsEndpoint = backingsEndpoint.endsWith('/') ? backingsEndpoint : `${backingsEndpoint}/`;

axios.defaults.withCredentials = process.env.REACT_APP_AXIOS_WITH_CREDENTIALS !== 'false';
